export default __webpack_public_path__ + "static/media/3.12d85a1e.jpg";